import { ProgressStyled, TextStyled } from "../../styles/stepProgressStyled";
import { Circle } from "./Circle";
import { useState, useEffect } from "react";
import { StagesData } from "../../interfaces/IStages";
import axios from "axios";
import { QUESTIONS_API_URL } from "../../env";
import styled from "styled-components";
import { T } from "../../styles/Theme";

interface IStepProgress {
  step: number;
  currentStep: number;
}

export const StepProgress = ({ currentStep }: IStepProgress) => {
  const [stage, setStage] = useState<StagesData[] | null>(null);
  const [percentage, setPercentage] = useState<number>(0);

  const getPercentage = (currentStage: number) => {
    if (currentStage === 1 || currentStage === 23) {
      setPercentage(0);
    } else if (currentStage === 2) {
      setPercentage(10);
    } else if (currentStage === 3) {
      setPercentage(20);
    }
  };

  useEffect(() => {
    const url = `${QUESTIONS_API_URL}/api/v1/stages/`;
    axios.get(url).then((res) => setStage(res.data.data));
    getPercentage(currentStep);
    // console.log(currentStep);
  }, [currentStep]);

  return (
    <>
      <ProgressStyled>
        {stage?.map((item, i) => {
          return (
            <div key={`${i}+${item.name}`} className="circleContainer">
              <Circle
                step={item.id}
                currentStep={currentStep}
                text={item.name}
              />
            </div>
          );
        })}
        {/* <div className="line"></div> */}
        <ProgressLineStyled percentage={percentage} />
      </ProgressStyled>
      <TextStyled>
        {stage?.map((item, i) => {
          return (
            <p
              key={`${i}+${item.name}`}
              className={currentStep >= item.id ? "textActive" : ""}
            >
              {item.name}
            </p>
          );
        })}
      </TextStyled>
    </>
  );
};

const ProgressLineStyled = styled.div<{ percentage: number }>`
  position: absolute;
  width: 75%;
  max-width: 300px;
  z-index: 1000;
  height: 5px;
  background: linear-gradient(
    to right,
    ${props => (props.percentage === 0) ? T.gray : T.blue} 0% 50%,
    ${props => (props.percentage <= 10) ? T.gray : T.blue} 50% 75%);
  @media (min-width: 480px) {
  position: absolute;
  width: 75%;
  max-width: 300px;
`;
